import React, { useContext } from "react";
import { getAppConfig } from "@config/appConfig";
import { PLACEHOLDER_MOVIE_POSTER } from "@config/ImageSizes";
import { AuthContext } from "@context/AuthContext";
import Loader from "@components/Ui/Loader";
import MovieSlider from "@components/V3/MoviesSlider";
import { getImageAtSize } from "@utils/imageUtils";


const CurrentlyShowing = () => {
    const { nowShowing, isMoviesLoading } = useContext(AuthContext);
    const config = getAppConfig();
    const fallbackPoster = `${config?.cdnUrl}${PLACEHOLDER_MOVIE_POSTER}`;

    if (isMoviesLoading) {
        return <Loader isLoading={isMoviesLoading} text="Fetching Movies" />;
    }

    if (!nowShowing || nowShowing.length === 0) {
        return (
            <p className="paragraph">Sorry there are no movies currently showing near you.</p>
        );
    }

    return (
        <MovieSlider
            title="Now Showing"
            movies={nowShowing}
            isLoading={isMoviesLoading}
            fallbackImage={fallbackPoster}
            baseClass="movie-slider"
            showVenueSelector={true}
            getMovieId={(m) => m.movie_id}
            getMovieTitle={(m) => m.movie_title}
            getMovieImage={(m) => getImageAtSize(m.movie_image, 428)}
        />
    );
};

export default CurrentlyShowing;
